import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
   static targets = [ "source", "button" ]
   static values = {
      successLabel: { type: String, default: "Copied!" },
      successDuration: { type: Number, default: 2000 }
   }

   copy() {
      const text = this.sourceTarget.textContent.trim()
      navigator.clipboard.writeText(text).then(() => this.#showSuccess())
   }

   #showSuccess() {
      if (!this.hasButtonTarget) return

      const originalText = this.sourceTarget.textContent
      this.sourceTarget.textContent = this.successLabelValue
      this.buttonTarget.disabled = true

      setTimeout(() => {
         this.sourceTarget.textContent = originalText
         this.buttonTarget.disabled = false
      }, this.successDurationValue)
   }
}
